import pasteIcon from './assets/icons/styled-paste.svg'
import reportIcon from './assets/icons/report.svg'
import highlightedMultiSelectIcon from './assets/icons/highlighted-multiselect.svg'
import multiSelectIcon from './assets/icons/multiselect.svg'
import unselectedHome from './assets/icons/nav/unselected-home.svg'
import unselectedCalendar from './assets/icons/nav/unselected-calendar.svg'
import unselectedChat from './assets/icons/nav/unselected-chat.svg'
import unselectedEvent from './assets/icons/nav/unselected-events.svg'
import selectedHome from './assets/icons/nav/selected-home.svg'
import selectedCalendar from './assets/icons/nav/selected-calendar.svg'
import selectedChat from './assets/icons/nav/selected-chat.svg'
import selectedEvent from './assets/icons/nav/selected-event.svg'
import folderIcon from './assets/icons/folders.svg'
import filterIcon from './assets/icons/filter.svg'
import highlightedFilterIcon from './assets/icons/highlighted-filter.svg'
import highlightedFolderIcon from './assets/icons/highlighted-folders.svg'
import copyIcon from './assets/icons/copy.svg'

export const DESTINATIONS = [
    {icon: unselectedEvent, selectedIcon: selectedEvent, path: '/events'},
    {icon: unselectedChat, selectedIcon: selectedChat, path: '/chat'},
    {icon: unselectedCalendar, selectedIcon: selectedCalendar, path: '/calendar'},
    {icon: unselectedHome, selectedIcon: selectedHome, path: '/home'},
]

export const STUDENT_SECOND_PRIORITY_DESTINATIONS = [
    {label: 'تنظیمات', path: '/settings'},
    {label: 'تحلیل آزمون', path: '/examAnalysis'},
    {label: 'برنامه هفتگی', path: '/weeklySchedule'},
    {label: 'گزارشات', path: '/report'},
    {label: 'لیگ زنده', path: '/league'},
    {label: 'وبینار', path: '/meetings'}
]

export const COUNSELOR_SECOND_PRIORITY_DESTINATIONS = [
    {label: 'تنظیمات', path: '/settings'},
    {label: 'پرونده', path: '/file'},
    {label: 'مشاهده تحلیل', path: '/examAnalysis'},
    {label: 'گزارشات', path: '/report'},
    {label: 'لیگ زنده', path: '/league'},
    {label: 'آزمون ها', path: '/exams'},
    {label: 'تنظیمات کوئیز', path: '/quizDefaultSettings'},
    {label: 'وبینار', path: '/meetings'}
]

export const COMPACT_STUDENTS_LIST_HEADER_OPTIONS = [
    {state: 'filter', image: filterIcon, selectedImage: highlightedFilterIcon},
    {state: 'folders', image: folderIcon, selectedImage: highlightedFolderIcon},
]

export const STUDENTS_LIST_HEADER_OPTIONS = [
    {state: 'filter', image: filterIcon, selectedImage: highlightedFilterIcon},
    {state: 'folders', image: folderIcon, selectedImage: highlightedFolderIcon},
    {state: 'multiselect', image: multiSelectIcon, selectedImage: highlightedMultiSelectIcon}
]

export const STUDENTS_MULTISELECT_LIST_HEADER_OPTIONS = [
    {state: 'multiselect', image: multiSelectIcon, selectedImage: highlightedMultiSelectIcon},
    {state: 'folders', image: folderIcon, selectedImage: highlightedFolderIcon},
    {state: 'report', image: reportIcon, selectedImage: reportIcon, intactUrl: true}
]

export const COUNSELOR_PLANNER_LIST_HEADER_OPTIONS = [
    {image: copyIcon, selectedImage: copyIcon, intactUrl: true, state: 'copy'},
    {image: pasteIcon, selectedImage: pasteIcon, intactUrl: true, state: 'paste'},
]

export const STUDENT_PLANNER_LIST_HEADER_OPTIONS = [
    {image: pasteIcon, selectedImage: pasteIcon, intactUrl: true, state: 'paste'},
]

export const THEMES = [
    // {label: 'custom', background: `linear-gradient(180deg, rgba(236,216,117,0.8) 4%, rgba(91,93,146,0.5) 92%)`},
    {label: 'custom', background: `url(/pattern.png), var(--green-theme)`},
    // {label: 'custom', background: `linear-gradient(90deg, #4540A9 4%, #B2A93B 92%)`},
    // {label: 'custom', background: `linear-gradient(90deg, rgb(76, 64, 245) 7%, #B64AA7 55%, rgb(255, 226, 54)  94%)`},
    {label: 'ice', background: `var(--pale-green-theme)`},
    {label: 'sunny', background: `var(--orange-theme)`},
    {label: 'patterned-ice', background: `url(/pattern.png), var(--pale-orange-theme)`},
    {label: 'patterned-sunny', background: ` url('/pattern.png'), var(--blue-theme)`},
]

export const STUDY_LEAGUE_BACKGROUND = [
    'linear-gradient(#FFF5D2, #EFCB4A)',
    'linear-gradient(#F5F5F5, #B1B1B1)',
    'linear-gradient(#FCEED9, #E09945)'   
]

export const WAKING_LEAGUE_BACKGROUND = [
    'url(/dawn.svg)',
    'url(/morning.svg)',
    'url(/noon.svg)',
]

export const QUICK_ACCESS_OPTIONS = [
    { label: 'چت', path: '/chat' },
    { label: 'گزارش', path: '/report' },
    { label: 'پرونده', path: '/file' },
    { label: 'برنامه دادن', path: '/calendar' },
    // { label: 'حذف دانش آموز', path: '/remove' }
]

export const BANNER_PLACEHOLDER = { image: '/pattern.png', mini_image_link: '/pattern.png', title: '', dominant_color: '' }

export const FILTER_KEYWORDS = [
    {label: 'ششم', key: 'filter-grade', value: '10', color: '#EDEDED'},
    {label: 'هفتم', key: 'filter-grade', value: '1', color: '#EDEDED'},
    {label: 'هشتم', key: 'filter-grade', value: '2', color: '#EDEDED'},
    {label: 'نهم', key: 'filter-grade', value: '3', color: '#EDEDED'},
    {label: 'دهم', key: 'filter-grade', value: '4', color: '#EDEDED'},
    {label: 'یازدهم', key: 'filter-grade', value: '5', color: '#EDEDED'},
    {label: 'دوازدهم', key: 'filter-grade', value: '6', color: '#EDEDED'},

    {label: 'ریاضی', key: 'filter-major', value: '1', color: '#EDEDED'},
    {label: 'تجربی', key: 'filter-major', value: '2', color: '#EDEDED'},
    {label: 'انسانی', key: 'filter-major', value: '3', color: '#EDEDED'},

    {label: 'فعال', key: 'filter-active', value: 'true', color: '#EDEDED'},
    {label: 'غیرفعال', key: 'filter-active', value: 'false', color: '#EDEDED'}
]

export const LEAGUE_FILTER_KEYWORDS = [
    {label: 'ششم', key: 'league-grade', value: '10', color: '#EDEDED'},
    {label: 'هفتم', key: 'league-grade', value: '1', color: '#EDEDED'},
    {label: 'هشتم', key: 'league-grade', value: '2', color: '#EDEDED'},
    {label: 'نهم', key: 'league-grade', value: '3', color: '#EDEDED'},
    {label: 'دهم', key: 'league-grade', value: '4', color: '#EDEDED'},
    {label: 'یازدهم', key: 'league-grade', value: '5', color: '#EDEDED'},
    {label: 'دوازدهم', key: 'league-grade', value: '6', color: '#EDEDED'},

    {label: 'ریاضی', key: 'league-major', value: '1', color: '#EDEDED'},
    {label: 'تجربی', key: 'league-major', value: '2', color: '#EDEDED'},
    {label: 'انسانی', key: 'league-major', value: '3', color: '#EDEDED'}
]

export const COUNSELOR_TOOLS = [
    {label: 'افزودن کوئیزها', value: '1', key: 'با یک کلیک کوئیزهای مربوط به تمام آیتم های درسی امروز را فعال کنید. این ویژگی در حالت غیرفعال کردن همه کوئیزها به صورت پیشفرض بسیار کاربردی است'},
    {label: 'افزودن روزخوانی', value: '2', key: 'با یک کلیک آیتم های مربوط به مرور درس امروز مدرسه را (با توجه به برنامه هفتگی دانش آموز) فعال کنید. استفاده از این ویژگی مستلزم وارد کردن برنامه هفتگی توسط دانش آموز است'},
    {label: 'افزودن درس فردا', value: '3', key: 'با یک کلیک آیتم های مربوط به مرور درس فردای مدرسه را(با توجه به برنامه هفتگی دانش آموز) فعال کنید. استفاده از این ویژگی مستلزم وارد کردن برنامه هفتگی توسط دانش آموز است'},
    {label: 'افزودن روتین', value: '4', key: 'روتین های شبانه یا هر مورد تکرار شونده دیگر را به راحتی در روزهای متعدد قرار دهید. استفاده از این قابلیت بسیار راحت تر از کپی پیست موارد می باشد'},
]

export const STUDY_METHODS = [
    {label: 'خلاصه برداری', value: '0'},
    {label: 'مرور', value: '1'},
    {label: 'فیلم آموزشی', value: '2'},
    {label: 'فلش کارت', value: '3'},
    {label: 'پیشخوانی', value: '4'},
    {label: 'سوال تشریحی', value: '5'},
    {label: 'روزخوانی', value: '6'},
]

export const TEST_METHODS = [
    {label: 'آموزشی', value: '0'},
    {label: 'سنجشی', value: '1'},
    {label: 'زماندار', value: '2'},
    {label: 'آزمون مشابه پارسال', value: '3'},
]

export const LEAGUE_TYPES = [
    {label: 'لیگ مطالعه', value: '1', key: 'timeData'},
    {label: 'لیگ تست', value: '2', key: 'testData'},
    {label: 'لیگ صبحگاهی', value: '3', key: 'wakingData'}
]

export const EXAM_TYPES = [
    {label: 'قلمچی', value: 'قلمچی'},
    {label: 'ماز', value: 'ماز'},
    {label: 'گزینه دو', value: 'گزینه دو'}
]

export const reasons = [
    {label: 'بلد نبودم', value: 0, group: 'ضعف دانش'},
    {label: 'نداشتن ایده حل', value: 1, group: 'ضعف دانش'},
    {label: 'به بودجه نرسیدم', value: 2, group: 'ضعف دانش'},
    {label: 'شک داشتم', value: 3, group: 'ضعف دانش'},
    {label: 'اشتباه محاسباتی', value: 4, group: 'ضعف تمرکز'},
    {label: 'اشتباه خواندن صورت', value: 5, group: 'ضعف تمرکز'},
    {label: 'جا به جا وارد کردن', value: 6, group: 'ضعف تمرکز'},
    {label: 'نرسیدم و بلد بودم', value: 7, group: 'ضعف سرعت عمل'},
    {label: 'نرسیدم و بلد نبودم', value: 8, group: 'ضعف سرعت عمل'},
    {label: 'سوال غلط بود', value: 9, group: 'سایر'},
    {label: 'خارج از بودجه آزمون', value: 10, group: 'سایر'}
]

export const weekDays = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه']

export const SEX = [
    { label: 'مرد', value: '1' }, 
    { label: 'زن', value: '2' }
]

export const REACTIONS = [
    'آفرین عزیزم',
    '👌❤️',
    'درود به شرفت',
    'خسته نباشی',
    'گزارشت عزیزم',
]

export const EXAM_DIFFICULTY_LEVELS = [
    { label: 'آسان', value: 'easy', color: 'green' },
    { label: 'متوسط', value: 'medium', color: 'gold' },
    { label: 'سخت', value: 'hard', color: 'red' },
    { label: 'بسیار سخت', value: 'veryHard', color: 'darkred' },
]

export const FILE_TYPES = [
    {label: 'یادداشت', type: 0, value: 'notes'},
    {label: 'تماس با دانش آموز', type: 1, value: 'reports'},
    {label: 'تماس با اولیا', type: 2, value: 'parents'},
    {label: 'جلسه حضوری', type: 3, value: 'meet'}
]

export const INTERVAL_COMPLETION_TYPES = [
    {label: 'دقیقا درون بازه', value: '1', color: '#00FF00'},
    {label: 'قبل از شروع بازه یا بعد از پایان آن', value: '2', color: '#0000FF'},
    {label: 'عدم انجام', value: '3', color: '#FF0000'},
    {label: 'اضافه شده', value: '4', color: '#FFA500'},
]

export const NON_STUDY_INTERVALS = [
    {label: 'کلاس آنلاین', value: 'کلاس آنلاین'},
    {label: 'کلاس آفلاین', value: 'کلاس آفلاین'},
    {label: 'خواب', value: 'خواب'},
    {label: 'ورزش', value: 'ورزش'},
    {label: 'هنر', value: 'هنر'},
    {label: 'سینما', value: 'سینما'},
    {label: 'رسانه', value: 'رسانه'}
]

export const MAP_PERSIAN_TO_ENGLISH = {
    'ا' : 'a',
    'آ' : 'u',
    'ب' : 'b',
    'پ' : 'p',
    'ت' : 't',
    'ث' : 'th',
    'ج' : 'j',
    'چ' : 'ch',
    'ح' : 'h',
    'خ' : 'kh',
    'د' : 'd',
    'ذ' : 'z',
    'ر' : 'r',
    'ز' : 'z',
    'ژ' : 'zh',
    'س' : 's',
    'ش' : 'sh',
    'ص' : 's',
    'ض' : 'z',
    'ط' : 't',
    'ظ' : 'z',
    'ف' : 'f',
    'ق' : 'gh',
    'ک' : 'k',
    'گ' : 'g',
    'ل' : 'l',
    'م' : 'm',
    'ن' : 'n',
    'و' : 'o',
    'ه' : 'h',
    'ی' : 'y',
}

export const RIAZI = [
    { title: 'ادبیات', image: 'https://api.risman.app/storage/images/UggoA9CLXv.jpeg', id: 2001, grade: 6, major: 1 },
    { title: 'عربی', image: 'https://api.risman.app/storage/images/QFmiNUdN3j.jpeg', id: 2002, grade: 6, major: 1 },
    { title: 'انگلیسی', image: 'https://api.risman.app/storage/images/j7Hj5owgLA.jpeg', id: 2003, grade: 6, major: 1 },
    { title: 'ریاضی', image: 'https://api.risman.app/storage/images/D8Qk3uki5o.jpeg', id: 2004, grade: 6, major: 1 },
    { title: 'هندسه', image: 'https://api.risman.app/storage/images/Io1Y940Lxx.jpeg', id: 2005, grade: 6, major: 1 },
    { title: 'فیزیک', image: 'https://api.risman.app/storage/images/EJrUBAm3kX.jpeg', id: 2006, grade: 6, major: 1 },
    { title: 'شیمی', image: 'https://api.risman.app/storage/images/Kr3CCmmRc1.jpeg', id: 2007, grade: 6, major: 1 },
]

export const TAJROBI = [
    { title: 'ادبیات', image: 'https://api.risman.app/storage/images/UggoA9CLXv.jpeg', id: 2001, grade: 6, major: 2 },
    { title: 'عربی', image: 'https://api.risman.app/storage/images/QFmiNUdN3j.jpeg', id: 2002, grade: 6, major: 2 },
    { title: 'انگلیسی', image: 'https://api.risman.app/storage/images/j7Hj5owgLA.jpeg', id: 2003, grade: 6, major: 2 },
    { title: 'ریاضی', image: 'https://api.risman.app/storage/images/D8Qk3uki5o.jpeg', id: 2004, grade: 6, major: 2 },
    { title: 'زیست شناسی', image: 'https://api.risman.app/storage/images/nD3YitH2mv.jpeg', id: 2008, grade: 6, major: 2 },
    { title: 'فیزیک', image: 'https://api.risman.app/storage/images/EJrUBAm3kX.jpeg', id: 2006, grade: 6, major: 2 },
    { title: 'شیمی', image: 'https://api.risman.app/storage/images/Kr3CCmmRc1.jpeg', id: 2007, grade: 6, major: 2 }
]

export const ENSANI = [
    { title: 'ادبیات', image: 'https://api.risman.app/storage/images/UggoA9CLXv.jpeg', id: 2001, grade: 6, major: 3 },
    { title: 'عربی', image: 'https://api.risman.app/storage/images/QFmiNUdN3j.jpeg', id: 2002, grade: 6, major: 3 },
    { title: 'انگلیسی', image: 'https://api.risman.app/storage/images/j7Hj5owgLA.jpeg', id: 2003, grade: 6, major: 3 },
    { title: 'ریاضی', image: 'https://api.risman.app/storage/images/D8Qk3uki5o.jpeg', id: 2004, grade: 6, major: 3 },
    { title: 'علوم انسانی', image: 'https://api.risman.app/storage/images/IUaRMmLYfk.jpeg', id: 2011, grade: 6, major: 3 },
]

export const COUNSELOR_QA = [
    { title: 'ادبیات', image: 'https://api.risman.app/storage/images/UggoA9CLXv.jpeg', id: 2001, grade: 6, major: 1 },
    { title: 'عربی', image: 'https://api.risman.app/storage/images/QFmiNUdN3j.jpeg', id: 2002, grade: 6, major: 1 },
    { title: 'انگلیسی', image: 'https://api.risman.app/storage/images/j7Hj5owgLA.jpeg', id: 2003, grade: 6, major: 1 },
    { title: 'ریاضی', image: 'https://api.risman.app/storage/images/D8Qk3uki5o.jpeg', id: 2004, grade: 6, major: 1 },
    { title: 'هندسه', image: 'https://api.risman.app/storage/images/Io1Y940Lxx.jpeg', id: 2005, grade: 6, major: 1 },
    { title: 'زیست شناسی', image: 'https://api.risman.app/storage/images/nD3YitH2mv.jpeg', id: 2008, grade: 6, major: 2 },
    { title: 'فیزیک', image: 'https://api.risman.app/storage/images/EJrUBAm3kX.jpeg', id: 2006, grade: 6, major: 1 },
    { title: 'شیمی', image: 'https://api.risman.app/storage/images/Kr3CCmmRc1.jpeg', id: 2007, grade: 6, major: 1 },
    { title: 'علوم انسانی', image: 'https://api.risman.app/storage/images/IUaRMmLYfk.jpeg', id: 2011, grade: 6, major: 3 }
]